<template>
  <div class="d-flex h-100 justify-content-center align-items-center">
      <div class="d-flex flex-column justify-content-center align-items-center">
        <float-label :dispatch="false">
          <vue-tel-input
              id="phone"
              class="auth-input pr-3 pl-0"
              :validCharactersOnly="true"
              :inputOptions = "{'placeholder': $t('state_customer.pl_tel')}"
              v-model="phoneNumber"
              @validate="validatePhone"
              name="r_phone"
              v-bind="bindProps">
          </vue-tel-input>
          <div v-if="isInvalidPhone" class="small text-danger warning-text">{{ $t('state_customer.valid_3') }}</div>
        </float-label>
        <div class="d-flex flex-column justify-content-start w-100">
          <p class="p font-weight-bold">Չունե՞ք բջջային ID SIM քարտ</p>
          <a href="https://ekeng.am/hy/mid_auth" target="_blank" class="small pointer font-weight-bold text-primary">Գրանցվեք</a>
        </div>
      </div>
  </div>

</template>

<script>
import purchaseTypesLongNamesCased from '@/mixins/purchaseTypes'

export default {
    name: 'contract_draft_product',
    mixins: [purchaseTypesLongNamesCased],
    props: ['handleLoaded', 'tender', 'order'],
    emits: ['validPhone'],
    data() {
        return {
          phoneNumber: '',
          isWithVat: false,
          isInvalidPhone: false,
          tenderData: {},
          buyer: {},
          seller: {},
          bindProps: {
            defaultCountry : "AM",
            autoDefaultCountry: false,
            dropdownOptions: {
              showDialCodeInList: true,
              showFlags: true,
              showDialCodeInSelection: true
            },
          },
        }
    },
    async mounted() {

    },
    computed: {
        me() {
            return this.$store.getters['user/me']
        },
    },
    watch: {},
    methods: {
      validatePhone (item) {
        const valid = item.valid;
        if (valid !== undefined){
          if(!item.valid){
            this.isInvalidPhone = true;
          }
          else{
            this.isInvalidPhone = false;
          }
          this.$emit('validPhone', this.isInvalidPhone)
        }
      },

    },
}
</script>
<style>
.option-box *{
    color: grey;
}
.option-box-selected *{
    color: red;
}
</style>
<style scoped>
    *{font-family: GHEA grapalat  !important;}
</style>
